import type { ClientNavigationContext, ComponentAppBootstrapView } from 'shared';
import type { RouteLocationNormalizedLoaded } from 'vue-router';

export function clientNavigationContext(
  route: Pick<RouteLocationNormalizedLoaded, 'name' | 'meta' | 'params' | 'query'>,
  currentWorkspaceId: string,
): ClientNavigationContext {
  const workspaceId =
    route.params.workspaceId ??
    (route.name === 'workspace-management' ? route.query.workspaceId : undefined) ??
    currentWorkspaceId;
  return {
    routeName: typeof route.name === 'string' ? route.name : null,
    routeTitle: typeof route.meta.title === 'string' ? route.meta.title : null,
    workspaceId:
      route.meta.requiresAuth && typeof workspaceId === 'string' && workspaceId
        ? workspaceId
        : null,
    pageId:
      ['workspace-page', 'workspace-component-app'].includes(String(route.name)) &&
      typeof route.params.pageId === 'string'
        ? route.params.pageId
        : null,
  };
}

export function componentAppNavigationContext(
  route: Parameters<typeof clientNavigationContext>[0],
  bootstrap: ComponentAppBootstrapView | undefined,
): ClientNavigationContext {
  const navigation = clientNavigationContext(route, '');
  const matches =
    bootstrap &&
    ((route.name === 'component-app-launch' && bootstrap.launchId === route.params.launchId) ||
      (['app-runtime', 'workspace-component-app'].includes(String(route.name)) && bootstrap.instanceId === route.params.instanceId));
  if (matches) {
    navigation.workspaceId = bootstrap.workspaceId;
    navigation.routeTitle = bootstrap.displayName;
    navigation.pageId = bootstrap.pageId;
  }
  return navigation;
}
